import {
  Box,
  IconButton,
  Modal,
  Paper,
  SxProps,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PropsWithChildren } from 'react';

const modalContainer: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const container: SxProps = {
  p: 2
};

const headerContainer: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};

export type ModalProps = PropsWithChildren<{
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  containerSx?: SxProps;
}>;

export const ModalContainer: React.FC<ModalProps> = ({
  open,
  onClose,
  children,
  subtitle,
  title,
  containerSx
}) => {
  return (
    <Modal onClose={onClose} open={open} sx={modalContainer}>
      <Paper
        sx={{
          ...container,
          ...containerSx
        }}
      >
        <Box>
          <Box sx={headerContainer}>
            <Typography variant="h6" fontWeight="600">
              {title}
            </Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography variant="body2" mt={1}>
            {subtitle}
          </Typography>
        </Box>

        <Box mt={2}>{children}</Box>
      </Paper>
    </Modal>
  );
};
